import * as React from "react";
import { motion } from "framer-motion";
import { ArrowLeftToLine, ArrowRightToLine } from "lucide-react";
import { SidebarFiles } from "@/modules/chat/components/SidebarFiles";

interface Props {
  systemId: string;
  isOpen: boolean;
  onToggle: () => void;
}

export const LeftSidebar: React.FC<Props> = ({ systemId, isOpen, onToggle }) => (
  <motion.div
    className="relative h-full flex-shrink-0 overflow-hidden border-r border-input bg-white/50"
    initial={false}
    animate={{ width: isOpen ? 320 : 45 }}
    transition={{ duration: 0.3, ease: "easeInOut" }}
  >
    <div className="absolute right-0 top-0 z-10 p-2">
      <button
        onClick={onToggle}
        className="rounded p-2 hover:bg-ivory-mist-100"
        title={isOpen ? "Collapse sidebar" : "Expand sidebar"}
      >
        {isOpen ? <ArrowLeftToLine size={20} /> : <ArrowRightToLine size={20} />}
      </button>
    </div>

    <div className="flex h-full w-[320px] flex-col pt-[52px]">
      <div
        className="flex-1 overflow-hidden border-t border-input transition-opacity duration-200"
        style={{ opacity: isOpen ? 1 : 0, pointerEvents: isOpen ? "auto" : "none" }}
      >
        <SidebarFiles systemId={systemId} />
      </div>
    </div>
  </motion.div>
);
